var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 31",
    x: 0,
    width: 42,
    height: 42,
    rx: 8,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "filter_alt"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_399_1821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box_2",
    x: 9,
    y: 9,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_399_1821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "filter_alt_2",
    d: "M20 29C19.7167 29 19.4792 28.9042 19.2875 28.7125C19.0959 28.5208 19 28.2833 19 28V22L13.2 14.6C12.95 14.2667 12.9125 13.9167 13.0875 13.55C13.2625 13.1833 13.5667 13 14 13H28C28.4334 13 28.7375 13.1833 28.9125 13.55C29.0875 13.9167 29.05 14.2667 28.8 14.6L23 22V28C23 28.2833 22.9042 28.5208 22.7125 28.7125C22.5209 28.9042 22.2834 29 22 29H20ZM21 21.3L25.95 15H16.05L21 21.3Z",
    fill: "#F25B08"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d28ae84609dbdbc5539c49a1851da50d.svg";
export { ForwardRef as ReactComponent };